export default __webpack_public_path__ + "static/media/check_mark_hover.23631bcb.svg";